import React from 'react';
import { getRem, keyframesAnimation } from 'lib/core';
import { NestedList, NestedListItemIcon } from 'lib/list';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { customNavScrollbar, slideDownKeyframesV2 } from '../shared-styles';

const StyledExpandedWrapper = styled.div`
  ${customNavScrollbar};
  display: flex;
  flex-direction: column;
  width: ${getRem(256)};
`;

const StyledNestedList = styled(NestedList)`
  ${NestedListItemIcon} {
    position: absolute;
    right: 0;
    margin-right: ${getRem(4)};
    padding-left: 0;
  }
  a,
  button {
    border-radius: ${getRem(8)};
    height: ${getRem(36)};
    margin-left: ${getRem(2)};
    svg {
      margin-right: ${getRem(2)};
      padding-right: 0;
    }
    &:not(:active) {
      background-color: transparent;
    }
    &:hover {
      background-color: ${({ theme }) => theme.color.gray[200].value};
    }
    &:active {
      background-color: ${({ theme }) => theme.color.gray[300].value};
    }
  }
  li {
    margin: ${getRem(8)} 0;
    padding-left: 0;
    width: ${getRem(240)};
    span {
      font-weight: 500;
    }
    a,
    button {
      padding-left: 0;
      div {
        width: 100%;
      }
    }
    ul {
      ${keyframesAnimation(slideDownKeyframesV2)};
      padding: ${getRem(8)} 0 0 0;
      margin: 0 0 ${getRem(13)} 0;
      li {
        margin: 0;
        a,
        button {
          height: ${getRem(32)};
          padding-left: ${getRem(32)};
          margin: 0.25rem 0 0.5rem 0.6rem;
          width: 14rem;
        }
        span {
          font-weight: 400;
        }
        ul {
          padding: 0;
          margin: 0 0 ${getRem(4)} 0;
          li {
            height: ${getRem(36)};
            a,
            button {
              padding-left: ${getRem(44)};
            }
            span {
              font-weight: 400;
            }
          }
        }
      }
    }
  }
  margin: 0 ${getRem(5)} 0 ${getRem(6)};
  padding: 0;
`;

export const NavListItemsExpanded = ({
  activeItemId = '',
  className,
  dataTestId = undefined,
  expandedItemIds = {},
  items,
  onItemExpandCollapse,
}) => {
  return (
    <StyledExpandedWrapper data-testid={dataTestId}>
      <StyledNestedList
        activeItemId={activeItemId}
        className={`${className}-list-item`}
        dataTestId={dataTestId ? `${dataTestId}-main-menu` : undefined}
        expandedItemIds={expandedItemIds}
        items={items}
        onItemExpandCollapse={onItemExpandCollapse}
      />
    </StyledExpandedWrapper>
  );
};

NavListItemsExpanded.propTypes = {
  /** Currently active navigation item id */
  activeItemId: PropTypes.string,
  /** Adds additional class to the component */
  className: PropTypes.string.isRequired,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** Item ids that are currently expanded. This prop consists of object entries, where key is the id of the item
   * and value is true if item is expanded and falsy (false, null, undefined) if it is not */
  expandedItemIds: PropTypes.shape({}),
  /** Items of navigation menu */
  items: PropTypes.arrayOf(PropTypes.shape({ ...NestedList.propTypes.items })).isRequired,
  /** Callback that is called on item expand or collapse */
  onItemExpandCollapse: PropTypes.func.isRequired,
};
